export default __webpack_public_path__ + "static/media/Jan_Vermeer_Girl_with_A_Pearl_Earring_40_x_60_cm.5894f494.jpg";